const Filter = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.039" height="18" viewBox="0 0 15.039 18">
      <g id="filter" transform="translate(-15.605 6.488)">
        <path
          id="Path_220"
          data-name="Path 220"
          d="M41.984,20.6a.681.681,0,0,1-.681-.682V4.682a.681.681,0,1,1,1.361,0V19.917A.681.681,0,0,1,41.984,20.6Z"
          transform="translate(-23.982 -9.787)"
          fill="#636363"
        />
        <path
          id="Path_221"
          data-name="Path 221"
          d="M40.117,18.866a.816.816,0,0,1-.814-.816V2.816a.814.814,0,1,1,1.628,0V18.05A.816.816,0,0,1,40.117,18.866Zm0-16.6a.548.548,0,0,0-.547.548V18.05a.547.547,0,1,0,1.094,0V2.816A.548.548,0,0,0,40.117,2.268Z"
          transform="translate(-22.116 -7.921)"
          fill="#636363"
        />
        <path
          id="Path_222"
          data-name="Path 222"
          d="M48.064,120.661a.134.134,0,0,1-.134-.134v-.864a.134.134,0,1,1,.267,0v.864A.134.134,0,0,1,48.064,120.661Z"
          transform="translate(-30.167 -117.584)"
          fill="#636363"
        />
        <circle
          id="Ellipse_41"
          data-name="Ellipse 41"
          cx="1.692"
          cy="1.692"
          r="1.692"
          transform="translate(15.605 -4.095) rotate(-45)"
          fill="#636363"
        />
        <path
          id="Path_223"
          data-name="Path 223"
          d="M48.424,4a1.7,1.7,0,0,0-.216.014,1.692,1.692,0,0,1,0,3.356A1.692,1.692,0,1,0,48.424,4Z"
          transform="translate(-30.426 -9.787)"
          fill="#636363"
        />
        <path
          id="Path_224"
          data-name="Path 224"
          d="M195.1,20.6a.681.681,0,0,1-.681-.682V4.682a.681.681,0,1,1,1.361,0V19.917A.681.681,0,0,1,195.1,20.6Z"
          transform="translate(-166.839 -9.787)"
          fill="#636363"
        />
        <path
          id="Path_225"
          data-name="Path 225"
          d="M193.23,18.866a.816.816,0,0,1-.814-.816V2.816a.814.814,0,1,1,1.628,0V18.05A.816.816,0,0,1,193.23,18.866Zm0-16.6a.548.548,0,0,0-.547.548V18.05a.547.547,0,1,0,1.094,0V2.816A.548.548,0,0,0,193.23,2.268Z"
          transform="translate(-164.972 -7.921)"
          fill="#636363"
        />
        <circle
          id="Ellipse_42"
          data-name="Ellipse 42"
          cx="1.692"
          cy="1.692"
          r="1.692"
          transform="translate(25.859 9.119) rotate(-45)"
          fill="#636363"
        />
        <path
          id="Path_226"
          data-name="Path 226"
          d="M201.537,201.322a1.693,1.693,0,0,0-.216.014,1.692,1.692,0,0,1,0,3.356,1.692,1.692,0,1,0,.216-3.37Z"
          transform="translate(-173.283 -193.895)"
          fill="#636363"
        />
        <path
          id="Path_227"
          data-name="Path 227"
          d="M180.909,204.705a1.7,1.7,0,0,0,.216-.014,1.692,1.692,0,0,1,0-3.356,1.71,1.71,0,0,0-.216-.014,1.692,1.692,0,0,0,0,3.384Z"
          transform="translate(-152.655 -193.894)"
          fill="#636363"
        />
        <path
          id="Path_228"
          data-name="Path 228"
          d="M118.541,20.6a.681.681,0,0,1-.681-.682V4.682a.681.681,0,1,1,1.361,0V19.917A.681.681,0,0,1,118.541,20.6Z"
          transform="translate(-95.411 -9.787)"
          fill="#636363"
        />
        <path
          id="Path_229"
          data-name="Path 229"
          d="M116.674,18.866a.816.816,0,0,1-.814-.816V2.816a.814.814,0,1,1,1.628,0V18.05A.816.816,0,0,1,116.674,18.866Zm0-16.6a.548.548,0,0,0-.547.548V18.05a.547.547,0,1,0,1.094,0V2.816A.548.548,0,0,0,116.674,2.268Z"
          transform="translate(-93.545 -7.921)"
          fill="#636363"
        />
        <circle
          id="Ellipse_43"
          data-name="Ellipse 43"
          cx="1.692"
          cy="1.692"
          r="1.692"
          transform="translate(21.434 0.712)"
          fill="#636363"
        />
        <path
          id="Path_230"
          data-name="Path 230"
          d="M179.044,202.973a1.826,1.826,0,1,1,1.826-1.826A1.828,1.828,0,0,1,179.044,202.973Zm0-3.384a1.559,1.559,0,1,0,1.559,1.559A1.56,1.56,0,0,0,179.044,199.589Z"
          transform="translate(-150.789 -192.028)"
          fill="#636363"
        />
        <path
          id="Path_231"
          data-name="Path 231"
          d="M124.981,101.044a1.7,1.7,0,0,0-.216.014,1.692,1.692,0,0,1,0,3.356,1.692,1.692,0,1,0,.216-3.37Z"
          transform="translate(-101.853 -100.332)"
          fill="#636363"
        />
        <path
          id="Path_232"
          data-name="Path 232"
          d="M104.353,104.428a1.7,1.7,0,0,0,.216-.014,1.692,1.692,0,0,1,0-3.356,1.692,1.692,0,1,0-.216,3.37Z"
          transform="translate(-81.229 -100.332)"
          fill="#636363"
        />
        <path
          id="Path_233"
          data-name="Path 233"
          d="M27.8,7.384a1.7,1.7,0,0,0,.216-.014,1.692,1.692,0,0,1,0-3.356,1.692,1.692,0,1,0-.216,3.37Z"
          transform="translate(-9.798 -9.787)"
          fill="#636363"
        />
        <g id="Group_317" data-name="Group 317" transform="translate(16.172 -5.921)">
          <path
            id="Path_234"
            data-name="Path 234"
            d="M102.487,102.7a1.826,1.826,0,1,1,1.826-1.826A1.828,1.828,0,0,1,102.487,102.7Zm0-3.384a1.559,1.559,0,1,0,1.559,1.559A1.56,1.56,0,0,0,102.487,99.311Z"
            transform="translate(-95.548 -92.563)"
            fill="#636363"
          />
          <path
            id="Path_235"
            data-name="Path 235"
            d="M25.93,5.651a1.826,1.826,0,1,1,1.826-1.826A1.828,1.828,0,0,1,25.93,5.651Zm0-3.384a1.559,1.559,0,1,0,1.559,1.559A1.56,1.56,0,0,0,25.93,2.267Z"
            transform="translate(-24.104 -2)"
            fill="#636363"
          />
        </g>
      </g>
    </svg>
  );
};

export default Filter;
